module.exports = __webpack_public_path__ + "img/homeillustration.8f13900e.png";